/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2023 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{makeProfilePredicate as e}from"@keeex/js-utils/lib/types/record.js";export const isVaultInfo=e({vaultUrl:"string",token:"?string"});export const isTokenRequestBodyV1=e({keyAddress:"?string",publicKey:"?string"});export const isTokenRequestBodyV2=e({version:{value:2},keyAddress:"?string"});export const isVaultTokenReply=e({token:"string"});